// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F5N6","clinicsSelect":"styles_clinicsSelect__2DJH1"};